import { render, staticRenderFns } from "./ANZTEXTFULL.vue?vue&type=template&id=2c7bd56c"
import script from "./ANZTEXTFULL.vue?vue&type=script&lang=js"
export * from "./ANZTEXTFULL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports